module.exports = __webpack_public_path__ + "media/images/icons/filled/ie-circle-72399c4af61f36b394e3adcd785eb3c5.svg";